import { render, staticRenderFns } from "./NovoExecutivo.vue?vue&type=template&id=2b5563dd"
import script from "./NovoExecutivo.vue?vue&type=script&lang=js"
export * from "./NovoExecutivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports